import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    Input,
} from '@angular/core';
import {
    MatDatepickerControl,
    MatDatepickerModule,
    MatDatepickerPanel,
} from '@angular/material/datepicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { CalendarDays, LucideAngularModule } from 'lucide-angular';

/**
 * Single calendar affordance for every date field in the app.
 *
 * Renders inside the form field (`matIconSuffix`) so the icon sits in the
 * field instead of next to it, and always draws the same Lucide
 * `calendar-days` glyph.
 */
@Component({
    selector: 'app-date-picker-toggle',
    imports: [
        MatDatepickerModule,
        MatTooltipModule,
        TranslocoModule,
        LucideAngularModule,
    ],
    providers: [provideTranslocoScope('codext')],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <mat-datepicker-toggle
            [for]="for"
            [disabled]="disabled"
            [matTooltip]="'codext.selectDate' | transloco">
            <lucide-icon
                matDatepickerToggleIcon
                [img]="CalendarDaysIcon"
                [size]="compact ? 16 : 18"></lucide-icon>
        </mat-datepicker-toggle>
    `,
    styleUrl: './date-picker-toggle.component.scss',
    host: {
        class: 'app-date-picker-toggle',
        '[class.app-date-picker-toggle--compact]': 'compact',
    },
})
export class DatePickerToggleComponent {
    readonly CalendarDaysIcon = CalendarDays;

    @Input({ required: true })
    for!: MatDatepickerPanel<MatDatepickerControl<any>, any>;

    /**
     * Unset by default so `mat-datepicker-toggle` keeps its own handling.
     * Pages that guarded their old calendar button pass the same expression.
     */
    @Input() disabled: boolean | undefined = undefined;

    /** Smaller hit area for the filter rows inside table headers. */
    @Input({ transform: booleanAttribute }) compact = false;
}
